import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Checkbox,
  Flex,
  FormElement,
  INPUT_NUMBER_VARIANT_DANGER,
  InputNumber,
  Text,
} from 'mailup-web-components'

import {
  modalBulkRemoveFromGroupsChangeCallback,
  modalBulkRemoveFromGroupsToggleOptMoveRandomCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalBulkRemoveFromGroups'
import { modalBulkRemoveFromGroupsState } from 'Pages/RecipientsList/recoil/state/modals'
import { selectionCountState } from 'Pages/RecipientsList/recoil/state/results'

const InputRandom: FC = () => {
  const intl = useIntl()

  const { optMoveRandom, moveRandomAmount, isMoveRandomAmountDirty } =
    useRecoilValue(modalBulkRemoveFromGroupsState)

  const selectionCount = useRecoilValue(selectionCountState)

  const toggleOptMoveRandom = useRecoilCallback(
    modalBulkRemoveFromGroupsToggleOptMoveRandomCallback,
    [],
  )

  const modalStateChange = useRecoilCallback(
    modalBulkRemoveFromGroupsChangeCallback,
    [],
  )

  const handleRandomAmountChange = (v: number | null): void => {
    void modalStateChange({
      moveRandomAmount: v === null ? undefined : v,
      isMoveRandomAmountDirty: true,
    })
  }

  const showFeedback: boolean =
    optMoveRandom &&
    (moveRandomAmount === undefined || moveRandomAmount == null) &&
    isMoveRandomAmountDirty

  return (
    <FormElement
      variant={showFeedback ? 'danger' : undefined}
      feedback={
        showFeedback
          ? intl.formatMessage({ id: 'Load.Common.ValidationWrongFormat' })
          : undefined
      }
    >
      <Flex alignItems="center" gap="8px">
        <Checkbox
          checked={optMoveRandom}
          data-mu-test="opt-move-random"
          label={intl.formatMessage({
            id: 'Load.RecipientsList.AddRandomBefore',
          })}
          onChange={toggleOptMoveRandom}
        />

        <InputNumber
          value={moveRandomAmount}
          min={1}
          max={selectionCount}
          data-mu-test="move-random-amount"
          onChange={handleRandomAmountChange}
          style={{ width: '120px' }}
          variant={showFeedback ? INPUT_NUMBER_VARIANT_DANGER : undefined}
        />

        <Text>
          {intl.formatMessage(
            { id: 'Load.RecipientsList.AddRandomAfter' },
            { count: selectionCount },
          )}
        </Text>
      </Flex>
    </FormElement>
  )
}

export default InputRandom
